module.exports = __webpack_public_path__ + "static/media/IMG_20170830_190221.0ad54f0c.jpg";